import { faLegal } from "@fortawesome/duotone-regular-svg-icons/faLegal";
import { faLock } from "@fortawesome/duotone-regular-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tabs } from "@mantine/core";
import { modals } from "@mantine/modals";

const POLICIES_MODAL_ID = "policies";

const openPoliciesModal = () => {
  modals.open({
    modalId: POLICIES_MODAL_ID,
    title: "Legal Stuff",
    withCloseButton: true,
    centered: true,
    size: "lg",
    children: (
      <>
        <Tabs defaultValue="privacy">
          <Tabs.List>
            <Tabs.Tab
              value="privacy"
              leftSection={<FontAwesomeIcon icon={faLock} />}
            >
              Privacy Policy
            </Tabs.Tab>
            <Tabs.Tab
              value="tos"
              leftSection={<FontAwesomeIcon icon={faLegal} />}
            >
              Terms of Service
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="privacy">
            <iframe
              src="https://app.getterms.io/view/dTYag/privacy/en-us"
              width="100%"
              height="400px"
            ></iframe>
          </Tabs.Panel>

          <Tabs.Panel value="tos">
            <iframe
              src="https://app.getterms.io/view/dTYag/tos/en-us"
              width="100%"
              height="400px"
            ></iframe>
          </Tabs.Panel>
        </Tabs>
      </>
    ),
    styles: {
      title: {
        flex: 1,
      },
      header: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  });
};

export { openPoliciesModal, POLICIES_MODAL_ID };
